module.exports = __webpack_public_path__ + "static/media/Frame 4.20f91a6a.jpg";